import React from 'react';

import { flagStyles } from '../settings';

const SvgFO = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1728px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgFO;
